export default "__VITE_ASSET__DVOCNBk2__"